import { render } from "./client-file.vue?vue&type=template&id=452bfc50"
import script from "./client-file.vue?vue&type=script&lang=js"
export * from "./client-file.vue?vue&type=script&lang=js"

import "./client-file.vue?vue&type=style&index=0&id=452bfc50&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__